/*
 * JUMO product comparison (README §6) — localStorage-based.
 * - Checkbox on product cards ([data-compare-checkbox]) adds/removes from comparison.
 * - Comparison bar (sticky bottom) appears when ≥1 product selected.
 * - "Jetzt vergleichen" button opens comparison page/drawer.
 * - "Leeren" clears all selections.
 * Works gracefully without JS (checkboxes still visible, but no functionality).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jumo_compare_products';
  var MAX_COMPARE = 6; // Maximum products to compare

  // ---- Localized strings ----
  var STRINGS = {
    added: 'Zum Vergleich hinzugefügt',
    removed: 'Aus Vergleich entfernt',
    max_reached: 'Maximal [max] Produkte vergleichbar',
    compare_count: '[count] Produkt(e) im Vergleich',
    clear: 'Leeren',
    compare_now: 'Jetzt vergleichen',
    error: 'Fehler beim Laden der Vergleichsprodukte'
  };
  try {
    var cfg = document.querySelector('[data-jumo-compare-strings]');
    if (cfg) {
      STRINGS = Object.assign(STRINGS, JSON.parse(cfg.textContent));
    }
  } catch (e) {
    /* keep defaults */
  }
  function format(template, vars) {
    return String(template).replace(/\[(\w+)\]/g, function (_, key) {
      return vars && vars[key] != null ? vars[key] : '';
    });
  }

  // ---- Storage helpers ----
  function getCompareList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setCompareList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage full or disabled */
    }
  }

  function addToCompare(productId, productHandle) {
    var list = getCompareList();
    // Check if already in list
    if (list.some(function (item) { return item.id === productId; })) {
      return { success: false, reason: 'duplicate' };
    }
    // Check max limit
    if (list.length >= MAX_COMPARE) {
      return { success: false, reason: 'max_reached' };
    }
    list.push({ id: productId, handle: productHandle });
    setCompareList(list);
    return { success: true };
  }

  function removeFromCompare(productId) {
    var list = getCompareList();
    var filtered = list.filter(function (item) { return item.id !== productId; });
    setCompareList(filtered);
    return { success: true };
  }

  function clearCompare() {
    setCompareList([]);
  }

  function isInCompare(productId) {
    var list = getCompareList();
    return list.some(function (item) { return item.id === productId; });
  }

  // ---- Toast notifications ----
  var toastTimer;
  function ensureToastHost() {
    var host = document.querySelector('.jumo-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'jumo-toast-host';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    return host;
  }

  function toast(message, isError) {
    var host = ensureToastHost();
    host.innerHTML = '';
    var el = document.createElement('div');
    el.className = 'jumo-toast' + (isError ? ' jumo-toast--error' : '');
    el.textContent = message;
    host.appendChild(el);
    // trigger transition
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 220);
    }, 2400);
  }

  // ---- Comparison bar (sticky bottom) ----
  function ensureCompareBar() {
    var bar = document.querySelector('.jumo-compare-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'jumo-compare-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', STRINGS.compare_now);
      bar.innerHTML =
        '<div class="jumo-compare-bar__content">' +
        '<span class="jumo-compare-bar__label">' +
        '<svg class="jumo-compare-bar__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="15 3 21 3 21 9"></polyline>' +
        '<polyline points="9 21 3 21 3 15"></polyline>' +
        '<line x1="21" y1="3" x2="14" y2="10"></line>' +
        '<line x1="3" y1="21" x2="10" y2="14"></line>' +
        '</svg>' +
        '<span class="jumo-compare-bar__count" data-compare-count></span>' +
        '</span>' +
        '<button type="button" class="jumo-compare-bar__clear" data-compare-clear>' + STRINGS.clear + '</button>' +
        '<button type="button" class="jumo-compare-bar__action" data-compare-action>' + STRINGS.compare_now + '</button>' +
        '</div>';
      document.body.appendChild(bar);
    }
    return bar;
  }

  function updateCompareBar() {
    var list = getCompareList();
    var bar = document.querySelector('.jumo-compare-bar');
    
    if (list.length === 0) {
      if (bar) {
        bar.classList.remove('is-visible');
        setTimeout(function () {
          if (bar.parentNode) bar.parentNode.removeChild(bar);
        }, 300);
      }
      return;
    }

    bar = ensureCompareBar();
    var countEl = bar.querySelector('[data-compare-count]');
    if (countEl) {
      countEl.textContent = format(STRINGS.compare_count, { count: list.length });
    }
    
    if (!bar.classList.contains('is-visible')) {
      // Trigger animation
      requestAnimationFrame(function () {
        bar.classList.add('is-visible');
      });
    }
  }

  // ---- Update all checkboxes on page ----
  function updateCheckboxes() {
    document.querySelectorAll('[data-compare-checkbox]').forEach(function (checkbox) {
      var productId = checkbox.getAttribute('data-product-id');
      if (productId) {
        checkbox.checked = isInCompare(productId);
      }
    });
  }

  // ---- Event handlers ----
  // Checkbox toggle
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-compare-checkbox]');
    if (!checkbox) return;

    var productId = checkbox.getAttribute('data-product-id');
    var productHandle = checkbox.getAttribute('data-product-handle');
    
    if (!productId) return;

    if (checkbox.checked) {
      var result = addToCompare(productId, productHandle);
      if (result.success) {
        toast(STRINGS.added);
        updateCompareBar();
        updateCheckboxes();
      } else {
        checkbox.checked = false;
        if (result.reason === 'max_reached') {
          toast(format(STRINGS.max_reached, { max: MAX_COMPARE }), true);
        }
      }
    } else {
      removeFromCompare(productId);
      toast(STRINGS.removed);
      updateCompareBar();
      updateCheckboxes();
    }
  });

  // Clear button
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-compare-clear]')) {
      event.preventDefault();
      clearCompare();
      updateCompareBar();
      updateCheckboxes();
    }
  });

  // Compare button - opens comparison page
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-compare-action]')) {
      event.preventDefault();
      var list = getCompareList();
      if (list.length === 0) return;

      // Build comparison URL: /pages/vergleich?products=handle1,handle2,handle3
      var handles = list.map(function (item) { return item.handle; }).filter(Boolean);
      if (handles.length === 0) {
        // Fallback: use IDs if handles not available
        var ids = list.map(function (item) { return item.id; });
        window.location.href = '/pages/vergleich?ids=' + ids.join(',');
      } else {
        window.location.href = '/pages/vergleich?products=' + handles.join(',');
      }
    }
  });

  // ---- Initialize on page load ----
  function init() {
    updateCheckboxes();
    updateCompareBar();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-sync on storage change (e.g., from another tab)
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      updateCheckboxes();
      updateCompareBar();
    }
  });

  // Re-sync when new product cards are injected (e.g. "load more")
  document.addEventListener('jumo:compare:sync', function () {
    updateCheckboxes();
    updateCompareBar();
  });
})();
